import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { ViewportService } from './../../services/viewport.service';
import { TableColumnInterface } from '../../interfaces/table-column.interface';
import { TableRowOptionsInterface } from '../../interfaces/table-row-options.interface';
import { TableColumnColorEnum } from 'src/app/shared/enums/table-column-color.enum';
import { isLastItem } from 'src/app/shared/utils/is-last-item.util';
import { TABLE_FAKE_COLUMN_NAME } from '../../constants/table-fake-column-name.constant';

import { HTMLSanitizer } from '../../utils/html-sanitizer.util';
import { ModalTableDescriptionComponent } from './modal-table-description/modal-table-description.component';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class TableComponent {
  @Input() columns: TableColumnInterface[];
  @Input() subColumns: TableColumnInterface[];
  @Input() rows: Record<string, any>[];
  @Input() subRows: Array<Record<string, any>[]>;
  @Input() rowOptionsMapper: Record<string, TableRowOptionsInterface>[];
  @Input() allowRowClick: boolean;
  @Input() cardLayoutForMobile = true;
  @Input() alternateLineColors = true;
  @Output() rowClickEvent = new EventEmitter();

  private displaySubRowsIndex: number;
  private isDesktopSubscription: Subscription;
  public isDesktop: boolean;
  public openSubRowsId = 'openSubRows';

  @Input() tituloBotaoSubLista = 'Solicitacões';
  @Input() realcaUltimaLinha = false;
  
  @ViewChild('modalDescription') modalDescription: ModalTableDescriptionComponent;
  
  get tableColumnColorEnum(): typeof TableColumnColorEnum {
    return TableColumnColorEnum;
  }

  get tableFakeColumnNameConstant(): string {
    return TABLE_FAKE_COLUMN_NAME;
  }

  constructor(private viewportService: ViewportService) {}

  ngOnInit(): void {
    this.isDesktopSubscription = this.viewportService.isDesktopObservable.subscribe((value) => {
      this.isDesktop = value;
    });
  
    if (this.subColumns && this.subColumns.length) {
      if (!this.columns.some((column) => column.name === this.openSubRowsId)) {
        this.columns.push({ name: this.openSubRowsId, displayName: '' });
      }
  
      this.rows = this.rows.map((item) => {
        return {
          ...item,
          [this.openSubRowsId]: ''
        };
      });
  
      this.rows.forEach((item, index) => {
        if (this.hasSubRowItems(index) && this.displaySubRowsIndex == null) {
          this.displaySubRowsIndex = index;
        }
      });
    }
  }
  
  ngOnDestroy(): void {
    if (this.isDesktopSubscription) {
      this.isDesktopSubscription.unsubscribe();
    }
  }

  private toggleDisplaySubRowItems(index: number): void {
    this.displaySubRowsIndex = this.displaySubRowsIndex === index ? null : index;
  }

  public isOdd(value: number): boolean {
    return value % 2 !== 0;
  }

  public getCellColor(index: number, column: TableColumnInterface): string {
    if (index != null)
      return this.rowOptionsMapper && this.rowOptionsMapper[index][column.name]?.color
        ? this.rowOptionsMapper[index][column.name].color
        : '';
    
    return '';    
  }
  
  public getCellClass(i: number, name: string): string {
    return this.rowOptionsMapper && 
           this.rowOptionsMapper[i] &&            
           this.rowOptionsMapper[i][name]?.description ?
          'screen-only' : '';
  }

  public clickable(i: number, name: string): string {
    return this.rowOptionsMapper && 
           this.rowOptionsMapper[i] && 
           (this.rowOptionsMapper[i][name]?.link ||             
            this.rowOptionsMapper[i][name]?.description);
  }

  public emitRowClick(row: Record<string, any>, index: number): void {
    if (this.allowRowClick) {
      this.rowClickEvent.emit(row);
    }

    if (this.hasSubRowItems(index)) {
      this.toggleDisplaySubRowItems(index);
    }
  }

  public handleCellClick(index: number, column: TableColumnInterface): void {
    if (!this.rowOptionsMapper || !this.rowOptionsMapper[index])
      return;

    const url = this.rowOptionsMapper[index][column.name]?.link;
    if (url) 
      window.open(url, '_blank');

    const description = this.rowOptionsMapper[index][column.name]?.description;
    if (description) 
      this.modalDescription.open(column.displayName, description);
  }

  public hasSubRowItems(index: number): boolean {
    return this.subRows && this.subRows[index] && this.subRows[index].length > 0;
  }

  public displaySubRowItems(index: number): boolean {
    return index === this.displaySubRowsIndex;
  }

  public getOpenSubRowIconName(index: number): string {
    return this.displaySubRowItems(index) ? 'flecha_cima' : 'flecha_baixo';
  }

  public getDisplaySubRowItemsButtonText(index: number): string {
    return this.displaySubRowItems(index) ? 'Esconder ' + this.tituloBotaoSubLista : 'Mostrar ' + this.tituloBotaoSubLista;
  }

  public getCardMarginBottomCondition(array: any[], index: number): boolean {
    return !this.isLastItem(array, index) && (!this.hasSubRowItems(index) || !this.displaySubRowItems(index));
  }

  public isLastItem(array: any[], index: number): boolean {
    const filteredArray = array.filter(
      (item) => !item?.name || (item?.name && item?.name !== this.openSubRowsId && item?.name !== TABLE_FAKE_COLUMN_NAME)
    );

    return isLastItem(filteredArray, index);
  }

  public isUltimaLinhaRealcar(index: number): boolean {
    return index === this.rows.length - 1;
  }

  public textoSemHtml(texto: string): string {
    return HTMLSanitizer(texto);
  }
}
